<section class="contact">
  @if (contactPerson; as contact) {
  <section class="contact__person">
    <ng-template #biographySocialMedia>
      @if (contact?.description) {
      <h2 class="contact__headline contact__headline--mobilereset" i18n="@@featureContactPersonPage-biography"
        >Biografie</h2
      >
      <planone-expandable-text
        [text]="contact?.description | TransformLinefeed | WYSIWYGTagFilter"
        backgroundColor="255, 255, 255"></planone-expandable-text>
      } @if (socialLinksPresent) {
      <h2 class="contact__headline" i18n="@@featureContactPersonPage-socialMediaProfile">Social Media Profile</h2>
      <div class="contact__social">
        @if (contact?.social_media?.linked_in) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.linked_in"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'LINKEDIN', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'LINKEDIN', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-linkedin" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">LinkedIn</span>
          </a>
        </div>
        } @if (contact?.social_media?.xing) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.xing"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'XING', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'XING', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-xing" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">Xing</span>
          </a>
        </div>
        } @if (contact?.social_media?.instagram) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.instagram"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'INSTAGRAM', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'INSTAGRAM', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-instagram" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">Instagram</span>
          </a>
        </div>
        } @if (contact?.social_media?.facebook) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.facebook"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'FACEBOOK', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'FACEBOOK', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-facebook" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">Facebook</span>
          </a>
        </div>
        } @if (contact?.social_media?.twitter) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.twitter"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'X', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'X', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-x" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">X</span>
          </a>
        </div>
        } @if (contact?.social_media?.youtube) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.youtube"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'YOUTUBE', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'YOUTUBE', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-youtube" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">Youtube</span>
          </a>
        </div>
        } @if (contact?.social_media?.pinterest) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.pinterest"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'PINTEREST', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'PINTEREST', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-pinterest" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">Pinterest</span>
          </a>
        </div>
        } @if (contact?.social_media?.tiktok) {
        <div class="contact__socialitem">
          <a
            [href]="contact?.social_media?.tiktok"
            class="contact__link"
            target="_blank"
            rel="noopener nofollow"
            (middleclick)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'TIKTOK', contact.id)"
            (click)="trackClick($event.currentTarget, 'SOCIAL_MEDIA_CONTACT_PERSON', 'TIKTOK', contact.id)">
            <div class="contact__socialicon">
              <mat-icon svgIcon="social-tiktok" class="contact__socialicon__content"></mat-icon>
            </div>
            <span class="contact__socialitem--underline">TikTok</span>
          </a>
        </div>
        }
      </div>
      }
    </ng-template>
    <header class="contact__summary">
      <bau365-breadcrumb [breadcrumbElements]="breadcrumbElements"></bau365-breadcrumb>
      @if (exhibitor?.mood_image?.resource) {
      <div
        class="contact__moodimage"
        [style]="
          'background-image: url(\'' +
          (exhibitor?.mood_image?.resource | ImageUrl : exhibitor?.mood_image?.provider : {
            width: 1920,
            height: 1080,
            fileType: ImageFileTypes.WEBP,
          }) +
          '\')'
        "></div>
      } @if (!exhibitor?.mood_image?.resource) {
      <div
        class="contact__moodimage"
        [style]="'background-image: url(\'assets/230511_BAU-Insights_1240x310_Moodbild_V1.webp\')'"></div>
      }
      <div class="contact__overlay">
        <div class="mdc-layout-grid actions">
          <div class="mdc-layout-grid__inner">
            <div
              class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone topnavi">
              <div class="topnavi__actions">
                <a class="actions__link" (click)="openShareButtonDialog($event)">
                  <mat-icon class="actions__icon">share</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
              <div class="contact__summarywrapper">
                <div class="contact__profilepicturewrapper">
                  @if (contact?.avatar?.resource) {
                  <div [style]="avatarStyle" class="contact__avatar"></div>
                  } @else {
                  <planone-profile-picture [size]="100">
                    <div class="contact__profilepicture contact__profilepicture--placeholder">
                      {{ this.initials }}
                    </div>
                  </planone-profile-picture>
                  }
                </div>
                @if ((size$ | async) !== 'phone') {
                <div class="contact__summarycontent">
                  <ng-container *ngTemplateOutlet="exhibitorContactHeadline"></ng-container>
                </div>
                }
              </div>
              @if ((size$ | async) === 'phone') {
              <br />
              <ng-container *ngTemplateOutlet="exhibitorContactHeadline"></ng-container>
              }
              <ng-template #exhibitorContactHeadline>
                @if (contact && isContributor(contact)) {
                <p class="contact__position">{{ contact.contributor_role }}</p>
                }
                <h1 class="contact__name mat-headline-1">{{ name }}</h1>
                @if (contact?.roles?.length) {
                <p class="contact__role">{{ (contact?.roles ?? []).join(', ') }}</p>
                } @if (contact.email) {
                <a
                  href="mailto:{{ contact.email }}"
                  class="contact__link contact__link--mail"
                  (middleclick)="trackClick($event.currentTarget, 'MAIL_CONTACT_PERSON', contact.email, contact.id)"
                  (click)="trackClick($event.currentTarget, 'MAIL_CONTACT_PERSON', contact.email, contact.id)">
                  <mat-icon class="contact__optionicon">mail</mat-icon>
                  <span class="contact__optionitem--underline">{{ contact.email }}</span>
                </a>
                }
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section class="contact__details">
      <div class="mdc-layout-grid contact__detailswrapper">
        <div class="mdc-layout-grid__inner">
          @if (contactInfoPresent) {
          <div
            class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
            <h2 class="contact__headline contact__headline--first" i18n="@@featureContactPersonPage-contactInfo"
              >Kontaktinformationen</h2
            >
            <div class="contact__options">
              @if (contact.phone) {
              <div class="contact__optionitem">
                <a
                  href="tel:{{ contact.phone }}"
                  class="contact__link"
                  (middleclick)="
                    trackClick($event.currentTarget, 'TELEPHONE_CONTACT_PERSON', contact.phone, contact.id)
                  "
                  (click)="trackClick($event.currentTarget, 'TELEPHONE_CONTACT_PERSON', contact.phone, contact.id)">
                  <mat-icon class="contact__optionicon">phone_in_talk</mat-icon>
                  <span class="contact__optionitem--underline">{{ contact.phone }}</span>
                </a>
              </div>
              } @if (contact.mobile) {
              <div class="contact__optionitem">
                <a
                  href="tel:{{ contact.mobile }}"
                  class="contact__link"
                  (middleclick)="trackClick($event.currentTarget, 'MOBILE_CONTACT_PERSON', contact.mobile, contact.id)"
                  (click)="trackClick($event.currentTarget, 'MOBILE_CONTACT_PERSON', contact.mobile, contact.id)">
                  <mat-icon class="contact__optionicon">smartphone</mat-icon>
                  <span class="contact__optionitem--underline">{{ contact.mobile }}</span>
                </a>
              </div>
              } @if (contact.fax) {
              <div class="contact__optionitem">
                <a
                  href="tel:{{ contact.fax }}"
                  class="contact__link"
                  (middleclick)="trackClick($event.currentTarget, 'FAX_CONTACT_PERSON', contact.fax, contact.id)"
                  (click)="trackClick($event.currentTarget, 'FAX_CONTACT_PERSON', contact.fax, contact.id)">
                  <mat-icon class="contact__optionicon">fax</mat-icon>
                  <span class="contact__optionitem--underline">{{ contact.fax }}</span>
                </a>
              </div>
              } @if (contact.website) {
              <div class="contact__optionitem">
                <a
                  [href]="contact.website"
                  class="contact__link"
                  target="_blank"
                  rel="noopener nofollow"
                  (middleclick)="
                    trackClick($event.currentTarget, 'HOMEPAGE_CONTACT_PERSON', contact.website, contact.id)
                  "
                  (click)="trackClick($event.currentTarget, 'HOMEPAGE_CONTACT_PERSON', contact.website, contact.id)">
                  <mat-icon class="contact__optionicon">globe</mat-icon>
                  <span class="contact__optionitem--underline" i18n="@@featureContactPersonPage-toHomepage"
                    >Zur Homepage</span
                  >
                </a>
              </div>
              }
            </div>
          </div>
          }
          <div
            class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
            @if ((size$ | async) === 'phone') {
            <ng-container *ngTemplateOutlet="biographySocialMedia"></ng-container>
            }
            <h2
              class="contact__headline contact__headline--column"
              i18n="@@featureContactPersonPage-exhibitorAndContact"
              >Aussteller &amp; Kontakt</h2
            >
            <planone-contact-exhibitor
              [hideDescription]="true"
              [hideLocation]="(hallPlanToggle$ | async) === false || (hallPlanActive$ | async) === false"
              [exhibitor]="exhibitor"
              (linkClick)="
                trackClick($event.element, $event.linkType, $event.linkText, contact.id)
              "></planone-contact-exhibitor>
          </div>
        </div>
      </div>
      @if ((socialLinksPresent || contact?.description) && (size$ | async) !== 'phone') {
      <div class="mdc-layout-grid contact__biography">
        <div class="mdc-layout-grid__inner">
          <div
            class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
            <ng-container *ngTemplateOutlet="biographySocialMedia"></ng-container>
          </div>
        </div>
      </div>
      }
    </section>
  </section>
  }
</section>
<ng-template #shareButtonsTitle>
  <span i18n="@@featureContactPersonPage-socialShareTitle">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="socialShareUrl"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
